import React from 'react';

import { styled } from '@mui/material';

import { LinkData, SubMenu } from '@mewa/types';
import { useVisibilityAnimation } from '@mewa/ui';

import {
  SHOW_COLUMN_DELAY,
  VISIBILITY_ANIMATION_REMOVE_DELAY,
} from './animation-constants';
import { AnimatedColumn, MenuColumn, StyledLink } from './link-columns';
import MenuWrapper from './menu-wrapper';

type Props = {
  langPrefix: string;
  show: boolean;
  overviewLink?: LinkData;
  columnStyle?: React.CSSProperties;
  columnData: SubMenu[];
  onClose: () => void;
};

const HeaderMenu = ({
  langPrefix,
  show,
  columnData,
  overviewLink,
  onClose,
}: Props) => {
  const [renderUI, showUI] = useVisibilityAnimation(
    show,
    VISIBILITY_ANIMATION_REMOVE_DELAY,
  );

  const overviewLinkComponent = (
    <AnimatedColumn
      transitionDelay={`${showUI ? SHOW_COLUMN_DELAY : 0}ms`}
      show={showUI}
      size={12}
    >
      {overviewLink ? (
        overviewLink.slug ? (
          <StyledLink to={`${langPrefix}/${overviewLink.slug}`}>
            <OverviewLink>{overviewLink.name}</OverviewLink>
          </StyledLink>
        ) : (
          <OverviewLink>{overviewLink.name}</OverviewLink>
        )
      ) : null}
    </AnimatedColumn>
  );

  return (
    <MenuWrapper
      renderUI={renderUI}
      showUI={showUI}
      show={show}
      onClose={onClose}
      overviewLinkComponent={overviewLinkComponent}
      transitionDelay={`${SHOW_COLUMN_DELAY + columnData.length * 80}ms`}
    >
      {renderMenuColumns(showUI, columnData, langPrefix)}
    </MenuWrapper>
  );
};

const renderMenuColumns = (
  showUI: boolean,
  columns: SubMenu[],
  langPrefix: string,
) => {
  const showColumnDelay = showUI ? SHOW_COLUMN_DELAY : 0;

  return columns.map((column, i) => (
    <MenuColumn
      key={i}
      title={column.title}
      slug={column.slug}
      show={showUI}
      langPrefix={langPrefix}
      links={column.links}
      transitionDelay={`${showColumnDelay + i * 80}ms`}
      size={12 / columns.length}
    />
  ));
};

const OverviewLink = styled('p')(({ theme }) => ({
  ...theme.typography.h6,
  marginTop: 0,
  marginBottom: '26px',
  display: 'inline-block',
}));

export default HeaderMenu;
